export default __webpack_public_path__ + "static/media/cf32ee49f9484daa.00157d86aadf2f819c49825fa339ad73.svg";